import {
  RECOMMENDATION_CATEGORY,
  Recommendation,
  RecommendationCategory,
  SEVERITY_WEIGHT,
  SeverityCounts,
} from './types';

export interface SelectedRecommendations {
  recommendations: Recommendation[];
  severityCounts: SeverityCounts;
  categorized: Record<RecommendationCategory, Recommendation[]>;
}

export const emptyCategorized: Record<
  RecommendationCategory,
  Recommendation[]
> = {
  [RECOMMENDATION_CATEGORY.GOVERNANCE]: [],
  [RECOMMENDATION_CATEGORY.SECURITY]: [],
  [RECOMMENDATION_CATEGORY.OPERATIONS]: [],
};

export const emptySeverityCounts: SeverityCounts = {
  error: 0,
  warning: 0,
  info: 0,
};

// Sort by severity (error > warning > info) then by title; also compute counts
// and the by-category grouping in a single pass. Intended as the select option
// for useRecommendations so TanStack Query memoises the transform per cache
// entry.
export function selectRecommendations(
  raw: Recommendation[]
): SelectedRecommendations {
  const recommendations = [...raw].sort(
    (a, b) =>
      SEVERITY_WEIGHT[b.severity] - SEVERITY_WEIGHT[a.severity] ||
      a.title.localeCompare(b.title)
  );

  const severityCounts: SeverityCounts = { error: 0, warning: 0, info: 0 };
  const categorized: Record<RecommendationCategory, Recommendation[]> = {
    [RECOMMENDATION_CATEGORY.GOVERNANCE]: [],
    [RECOMMENDATION_CATEGORY.SECURITY]: [],
    [RECOMMENDATION_CATEGORY.OPERATIONS]: [],
  };

  recommendations.forEach((rec) => {
    severityCounts[rec.severity]++;
    categorized[rec.category].push(rec);
  });

  return { recommendations, severityCounts, categorized };
}
